import { gql } from "lib/apolloClient";
import {
  organizationAssignmentsFragment,
  courseFragment,
  studentSubjectSummaryPypRatingFragment,
  studentProgressReportFragments,
} from "./ProgressSummaryFragments";

export const getOrganizationAssignmentsProgressSummaryQuery = gql`
  query getOrganizationAssignmentsProgressSummary(
    $organizationId: ID!
    $courseIds: [ID!]
    $contentTypes: [ASSIGNMENT_CONTENT_TYPE_ENUM!]
    $isTeacherEvaluationEnabled: Boolean
    $assessmentTypes: [String!]
    $assessmentToolTypes: [ASSESSMENT_EVALUATION_TYPE_ENUM!]
    $isAssessmentScoringEnabled: Boolean
    $searchText: String
    $excludedAssessmentTypes: [String!]
    $academicTermIds: [ID!]
    $categoryIds: [ID!]
    $groupTypes: [ASSESSMENT_TYPE_ENUM!]
    $first: Int
    $after: String
    $subjectIds: [ID!]
    $courseMapFilters: UserCourseMapFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationAssignmentItem
      }
    }
  }
  ${organizationAssignmentsFragment.organizationAssignmentProgressSummary}
`;

export const getCourseDetailsQuery = gql`
  query getCourseDetails($id: ID!, $courseGradeFilters: CourseGradeFilters) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        ...courseDetailsItem
      }
    }
  }
  ${courseFragment.courseDetails}
`;

export const getStudentsPypElementRatingsQuery = gql`
  query getStudentPypEvaluation(
    $studentIds: [ID!]
    $filtersForRecentMost: ibPYPElementRatingFilterForRecentMost
    $startDate: String
    $endDate: String
  ) {
    multiNode(ids: $studentIds, type: STUDENT) {
      id
      ... on Student {
        id
        ibPYPElementRatings(
          filtersForRecentMost: $filtersForRecentMost
          dataSet: MOST_RECENT
          startDate: $startDate
          endDate: $endDate
        ) {
          ...ratingItem
        }
      }
    }
  }
  ${studentSubjectSummaryPypRatingFragment.studentElementRating}
`;

export const getAcademicCriteriaSetsQuery = gql`
  query getAcademicCriteriaSets(
    $organizationId: ID!
    $filters: academicCriteriaSetsFilter
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        constants {
          academicCriteriaSets(filters: $filters) {
            id
            label
            academicCriteriaValues {
              id
              label
              abbreviation
              localGrades {
                id
                grade {
                  id
                }
                label
              }
              boundaryGuidelines
            }
            criteriaType
          }
        }
      }
    }
  }
`;

export const getCourseAcademicYearTermsQuery = gql`
  query getCourseAcademicYearTerms($id: ID!, $curriculumProgramIds: [ID!]) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        academicYears {
          id
          isCurrentAcademicYear
          startDate
          endDate
          terms(filters: { curriculumProgramIds: $curriculumProgramIds }) {
            id
            label
            startDate
            endDate
            type
          }
        }
      }
    }
  }
`;

export const getIBGradeAssignmentsQuery = gql`
  query getIBGradeAssignments(
    $courseId: ID!
    $filters: AssignmentFeedFilters
    $orderBy: ASSIGNMENT_ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $studentIds: [ID!]
  ) {
    node(id: $courseId, type: COURSE) {
      id
      ... on Course {
        assignments(
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          edges {
            node {
              id
              content {
                id
                ... on Assessment {
                  title {
                    id
                    value
                  }
                  assessmentType {
                    id
                    value
                  }
                }
              }
              assignedStudents(studentIds: $studentIds) {
                student {
                  id
                }
                ibPYPElementRatings {
                  id
                  value
                  ibPYPElementId
                  ibPYPElementType
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getStudentPublishedReportDetailsQuery = gql`
  query getPublishedStudentProgressReportBasicDetails(
    $ids: [ID!]
    $filters: PublishedProgressReportsFilter
  ) {
    multiNode(ids: $ids, type: STUDENT) {
      id
      ... on Student {
        id
        publishedProgressReports(filters: $filters) {
          ...publishedStudentProgressReportItem
        }
      }
    }
  }
  ${studentProgressReportFragments.publishedReportBasicDetails}
`;

export const getPublishedProgressReportTemplateQuery = gql`
  query getPublishedProgressReportTemplate(
    $id: ID!
    $templateFilters: StudentReportTemplateFilter
  ) {
    node(id: $id, type: PUBLISHED_STUDENT_PROGRESS_REPORT) {
      id
      ... on PublishedStudentProgressReport {
        id
        studentProgressReport {
          id
          publishedReport {
            id
            template(filters: $templateFilters)
          }
        }
      }
    }
  }
`;
